var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flash flash--success flash--close",attrs:{"role":"alert"},on:{"click":function($event){return _vm.$emit('close')}}},[_c('strong',{domProps:{"innerHTML":_vm._s(_vm.notification.title)}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.notification.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }